import React from "react"
import {Container, Row, Col} from "reactstrap";
import "./app.css"
import TileContainer from "../containers/TitleContainer"
import sandwichBarMenu from "../assets/sandwichbarmenu.jpeg"
const FoodToGo = () => {

    return(
        <Container fluid>
        <TileContainer title={"Sandwich Bar"}/>
        <Row className="row-m-20">
            <Col md={{size: 8, offset: 2}} className="remove-padding">
                <div className="textContainer" style={{textAlign:"center"}}>
                    <h3 style={{marginBottom: 12}}>Sandwich Bar Menu</h3>
                    <p style={{marginBottom: 16}}>
                        Our sandwich bar menu is now available.
                    </p>
                    <img
                        src={sandwichBarMenu}
                        alt="White Hart sandwich bar menu"
                        className="shadow-image"
                        style={{width: "100%", maxWidth: 700, height: "auto"}}
                    />
                </div>
            </Col>

        </Row>
</Container>
    )
}

export default FoodToGo
